import { ObservationSource } from '@jack-henry/frontend-utils/observable';
import { TmBaseComponent } from '@treasury/presentation';
import { html } from 'lit';
import { customElement, query } from 'lit/decorators.js';

/**
 * Observable that emits any time an `AppComponent` instance becomes connected to the DOM.
 */

const readySource = new ObservationSource<AppComponent>();

export const tagName = 'app-component';
@customElement(tagName)
export class AppComponent extends TmBaseComponent {
    public static async getOutlet() {
        const app = await readySource.toPromise(true);
        return app.outlet;
    }

    @query('#outlet')
    private outlet!: Promise<HTMLElement>;

    protected render() {
        return html`<main id="outlet"></main>`;
    }

    protected firstUpdated(): void {
        readySource.emit(this);
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: AppComponent;
    }
}
